import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import MetadataDrivenUtil from 'edge/api/gw-portals-driven-ui-js/MetadataDrivenUtil';
import flowConfigUtil from 'edge/quoteandbind/common/util/FlowConfigUtil';

/**
 * This function prepares some common actions to be used in flow configuration
 *
 * @param {Object} dependencies
 * @param {Object} dependencies.$q a Promise implementation
 * @param {Object} dependencies.LoadSaveService
 * @param {Object} dependencies.ViewModelService
 * @param {Object} dependencies.ViewModelContext
 *
 * @returns {Object} a set of common Flow actions 'ret.ACTIONS' an their respective message 'ret.ACTIONS_MSG' to be used across all the custom flows
 */

const mockUpUtil = new MockUpUtil();

const fn = ($filter, $scope, $state, $stateParams, CustomQuoteService, $translate,
    ViewModelService, InsuranceSuiteMetadata, UserInfoService, ModalService) => {
    const ctrl = Object.create(BaseCtrl);



    ctrl.init = () => {
        $scope.isSuperuser = PSAUSER.isSuperuser;
        if (!PSAUSER.isSuperuser) {
            ModalService.showError('gateway.views.modal.Error', 'Permission Denied');
        }
        else {
            var RedWireDTO = {};
            $scope.submissionView = ViewModelService.create(RedWireDTO, 'pc', 'edge.capabilities.quote.submission.dto.RedWireRuleDTO');
        }
    };
    $scope.$watch('submissionView.country.value', (newValue) => {
        ctrl.getRedWireMsg();
    });

    ctrl.getRedWireMsg = function () {
        var currentCountry = $scope.submissionView.country.value;
        if (currentCountry !== undefined && currentCountry !== "") {
            const operation = CustomQuoteService.getRedWireMsg(currentCountry.code);
            operation.then((result) => {

                $scope.submissionView.redWireMessage = result.redWireMessage;

            }).catch((err) => {

            });
        }
    }
    
    ctrl.cancel = function () {
        window.location.hash = "#/home"
    };
    ctrl.save = function (form) {
        form.submitted = true;
        if (form.invalid) {
            return;
        }
        var countryCode = $scope.submissionView.country.value.code;
        var redWireMsg = $scope.submissionView.redWireMessage.value;
        const operation = CustomQuoteService.updateRedWireSetting(countryCode, redWireMsg);
        operation.then((result) => {
            console.log(result);
            ModalService.showInfo('gateway.views.account-detail.Saved Title', 'gateway.views.account-detail.Saved Message');
        }).catch((error) => {
            ModalService.showError('gateway.views.modal.Error', 'quoteandbind.views.contact-us.Please contact us with the reference number below and we would be pleased to assist you.');
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', 'qnb.CustomQuoteService', '$translate', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService', 'ModalService'];
export default fn;
